module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower2-4b707ec97b0aa2b206b47ae1a3464295.svg";